import { Media } from "@app/types/Cue";
import { DrupalVideo } from "@app/types/Drupal";
import BasicCard from "@components/ArticleCard/BasicCard";
import { CardVariations } from "@components/ArticleCard/types";
import cx from "classnames";

export type VideosStoriesProps = DrupalVideo & {
  index: number;
};

export default function VideosStories({
  video_id,
  video_thumbnail,
  video_title,
  video_url,
  index,
}: VideosStoriesProps): React.ReactElement {
  const isLeadArticle = index === 0;
  const media: Media = {
    content: {
      type: "picture",
      fields: {
        landscape: {
          url: video_thumbnail,
        },
      },
    },
  };

  const variant: CardVariations = {
    image: {
      position: "",
      width: "w-120px lg:w-full",
      isVideo: true,
      extraClass: "h-fit",
      aspectRatio: "aspect-16x9",
    },
    content: {
      width: "w-full-120px lg:w-full",
      extraClass: cx({
        "pl-4 lg:pl-0 lg:pt-4": isLeadArticle,
      }),
    },
    title: {
      color: "text-gray-850",
      size: isLeadArticle ? "text-lg" : "text-base",
    },
  };

  return (
    <div className="video border-b border-gray-175 py-3">
      <BasicCard
        id={video_id}
        slug={video_url}
        title={video_title}
        variations={variant}
        media={isLeadArticle ? media : undefined}
      />
    </div>
  );
}
